export default __webpack_public_path__ + "static/media/app-store.3e029ef0.png";